<template>
  <div>
    <!-- <div class="top_img">
      <img :src="picpreFix + orderDetail.mainPic" alt="" />
    </div> -->
    <div class="container">
      <div class="museumInformation">
        <div class="shawdow"></div>
        <img
          mode="aspectFill"
          class="topImg"
          src="http://static.bowu66.com/museum-voice/2021-10-28/68cf2eb963884d60984bb953f6458aa6.jpg"
        />
        <div class="topTitle">
          <img src="http://static.bowu66.com/wenlv/31.png" alt="" />
          <div class="museumName">{{ orderDetail.name }}</div>
        </div>
        <div class="topTitle2">
          <img src="http://static.bowu66.com/wenlv/32.png" alt="" />
          <div class="museumIntroduce">
            {{ orderDetail.openingInformation }}
          </div>
        </div>
      </div>

      <!-- 预约时间 -->
      <div class="timeChoose">
        <van-cell
          style="padding: 0 16px"
          is-link
          @click="showPopup"
          arrow-direction="down"
          ><span class="travelDate_text">预约日期</span>
          <span
            style="margin-left: 20px; color: #969696"
            class="travelDate_text"
            >{{ week }}</span
          >
          <span class="travelDate_text2">{{ currentDate }}</span></van-cell
        >
        <van-cell
          style="padding: 0 16px"
          is-link
          @click="showSession"
          arrow-direction="down"
          ><span class="sessionTime_text">到馆时间</span
          ><span
            style="margin-left: 20px; color: #969696"
            class="travelDate_text"
            >剩余名额：{{ perSonNum }}</span
          >
          <span class="sessionTime_text2">{{ sessionTime }}</span></van-cell
        >
        <van-cell style="padding: 0 16px">
          <view class="contentView" v-if="openTeamAppointment">
            <view bindtap="alert1" class="contentView_title">
              预约类型
              <img :src="localPic + '148.png'" />
            </view>
            <view class="contentView_choose">
              <view
                class="contentView_choose_item"
                bindtap="chooseType"
                data-bool="个人预约"
              >
                <view class="contentView_choose_item_icon">
                  <img
                    v-if="appointmentType == '个人预约'"
                    :src="localPic + '150.png'"
                  />
                  <img v-else :src="localPic + '149.png'" />
                </view>
                <view class="contentView_choose_item_p">个人预约</view>
              </view>
              <view
                class="contentView_choose_item"
                bindtap="chooseType"
                data-bool="团队预约"
              >
                <view class="contentView_choose_item_icon">
                  <img
                    v-if="appointmentType == '团队预约'"
                    :src="localPic + '150.png'"
                  />
                  <img v-else :src="localPic + '149.png'" />
                </view>
                <view class="contentView_choose_item_p">
                  <view>团队预约</view>
                  <view style="font-size: 20rpx"
                    >{{ data.teamLimitMin }}人 - {{ data.teamLimitMax }}人</view
                  >
                </view>
              </view>
            </view>
          </view>
        </van-cell>
      </div>

      <!-- 添加游客 -->
      <div
        class="addVisitors"
        @click="addVisitor"
        v-if="!$store.state.perSon.length"
      >
        <van-cell
          ><span class="add_one">添加游客</span
          ><span class="add"
            ><img
              src="data:image/png;base64,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"
              alt="" /></span
        ></van-cell>
      </div>

      <!-- 选择游客 -->
      <div class="chooseVisitors" v-if="$store.state.perSon.length">
        <div class="choose_title">
          <div class="appellation">
            添加用户称谓
            <div class="singleLimit">
              每次最多预约{{ orderDetail.singleLimit }}人
            </div>
          </div>

          <div class="qingchu" @click="qingchu">清除游客记录</div>
          <!-- <div class="perSon_information3">
            <span class="chooseImg"
              ><img
                src="data:image/png;base64,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"
                alt=""
            /></span>
            <span class="addText" @click="getFamily">获取家庭关系</span>
          </div> -->
        </div>

        <div class="choose_person">
          <div
            class="perSon_information"
            :class="{ selected: item.isSelected }"
            v-for="(item, index) in $store.state.perSon"
            :key="index"
            @click="checked(item, index)"
          >
            {{ item.name }}
          </div>
          <div class="perSon_information2">
            <span class="chooseImg"
              ><img
                src="data:image/png;base64,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"
                alt=""
            /></span>
            <span class="addText" @click="addVisitor">新增</span>
          </div>
        </div>

        <van-cell  v-for="(item, index) in selected" :key="index">
          <div class="perSon_Detail">
            <div style="display:flex;align-items:center">

               <div class="perSon_delete" @click="deletePerson(index)">
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAaVBMVEUAAAD/QGD/QGr/QGD/TmT/Smr/TGj/SWT/SWb/R2P/Smv/SWn/SWj/TGb/S2n/Smj/TWj/TWr/TGn/TGj/TGn/TWn/TWr/TGr/TWr/TGr/TWr/TWn/TGr/TGn/TWn/TWr/TWr/TGn/TWpeGcZbAAAAInRSTlMACAwQFxgbHCMkNzg7PF9gZ2dof6+zt8PLz9ff5+vr7/P3D+WWWAAAAPFJREFUSMftVV0TgiAQRIzMPjC1qwBL3P//I3tqJi7EYaanat/uZheP89gT4o9MrI7kJgSYHB1XM3TZM/ITvpcx/toA1NRFmC3qhgCzfudXA+wu/umDxVC91WNwKefuVl5geFU9bDnfjdKiDzNqwi7VvwO8ChItKN1xQsviJi1o2IkOdVpQwwXxhCItkPBBDCyNDWN8l6C9vU72qBcFY/gW7p8XtPfMkn7ox2WPd/YDOkOnBRqnIO6WTaDjNrNN8ffcZrKNbNEqrzJmxjNV7S0GFbFvA5DesJPkRhNwreILxWctFCGE6sgxkXfUqf8yz8UDuE8nweh5kicAAAAASUVORK5CYII="
                alt=""
              />
            </div>
            <div class="perSon_cardInformation">
              <div class="name">{{ item.name }}</div>
              <div class="cardNum">{{ item.cardNum }}</div>
            </div>
            </div>
           
            <div class="perSon_ediot" @click="ediot(index)">编辑</div>
          </div>
        </van-cell>
      </div>

      <!-- 我的历史订单 -->

      <div class="myHistory">
        <div class="myHistory_text" @click="myHistory">我的预约记录 ></div>
      </div>
    </div>

    <!-- 底部预约模块 -->
    <!-- <div class="yuyueBottom_one">您正在前往第三方预约平台</div> -->
    <div class="yuyueBottom_two">
      <div class="num">
        共<span class="number">{{ selected.length }}</span
        >人
      </div>

      <div class="yuyueButton_box">
        <div class="yuyueButton" @click="yuyue">立即预约</div>
      </div>
    </div>

    <!-- 时间选择弹出框 -->
    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
      <van-calendar
        v-model="show"
        title="请选择日期"
        color="#00ae7e"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="chooseTime"
        id="calendar"
      />
    </van-popup>

    <!-- 入场时间选择弹出框 -->
    <van-popup v-model="show1" position="bottom" :style="{ height: '40%' }">
      <van-picker
        title="标题"
        show-toolbar
        :columns="sessionTimeArr"
        value-key="sessionTime"
        @confirm="sessionConfirm"
        @cancel="close"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
import { mapGetters } from "vuex";
import {
  TravelDate,
  picpreFix,
  OrderDetail,
  getSession,
  Appointment,
  getClosed,
  museumDetail,
  ReservationMuseum,
  clearTravelerTemplates,
} from "../api/api";
import base from "../../utils/base64";
import axios from "axios";
const {
  formatTime2,
  formatTime3,
  timeToSec,
  trim,
} = require("../../utils/util.js");
export default {
  data() {
    return {
      week: "",
      showCalendar: false,
      museumInformation: "", //博物馆详情
      picpreFix,
      travelDate: "", //出行日期
      orderDetail: "", //预约详情
      show: false, //出行日期弹出框
      currentDate: new Date(),
      year: "",
      perSon: {}, //出行人信息
      sessionTimeArr: [], //到馆时间数组,
      sessionTime: "",
      show1: false, //到馆时间弹出框
      perSonNum: "", //当前剩余名额
      yuyueId: "", //预约成功后的id
      minDate: "",
      maxDate: "",
      Reservation: "",
      openTeamAppointment: false,
      closeWeekArr: [],

      //  defaultDate: new Date().getTime(),
    };
  },

  created() {},
  mounted() {
   iCityBridge.setTitle('兴安盟科学技术馆预约');
    // this.museumDetail();
    this.getTravelDate();
    this.getAllDate();
    this.getClosedDate();
    this.getWeek();
    this.ReservationMuseum();
    console.log(this.$store.state.perSon);
  },
  updated() {
    console.log(this.$store.state.perSon);
  },
  computed: {
    ...mapGetters(["selected"]),
  },
  methods: {
    chooseTime(e) {
      console.log(e);
      let date = formatTime2(new Date(e));
      console.log(date);
      this.show = false;
      this.currentDate = date;
      // 获取当前洲周几
      this.getWeek();
      this.getSessionTime();
      //  this.getRestQuota()
    },
    getWeek() {
      // 得到周几

      let num = new Date(this.currentDate).getDay(),
        text = "";
      switch (num) {
        case 1:
          text = "周一";
          break;
        case 2:
          text = "周二";
          break;
        case 3:
          text = "周三";
          break;
        case 4:
          text = "周四";
          break;
        case 5:
          text = "周五";
          break;
        case 6:
          text = "周六";
          break;
        case 0:
          text = "周日";
          break;
      }
      this.week = text;
      console.log(this.week);
    },
    //获取traveldate时间
    getTravelDate() {
      TravelDate({ museumId: this.museumId }).then((res) => {
        this.travelDate = res.data.data;
      });
    },
    //获取当前预约馆的详情
    // museumDetail() {
    //   museumDetail({ museumId: this.museumId }).then((res) => {
    //     this.orderDetail = res.data.data;
    //     console.log(this.orderDetail);

    //     if (this.orderDetail.enableAppointmentThatDay) {
    //     }
    //   });
    // },
    ReservationMuseum() {
      ReservationMuseum({ appMuseumId: this.museumId }).then((res) => {
        this.orderDetail = res.data.data.records[0];
        console.log(this.orderDetail.name);

        this.minDate = new Date();
        console.log(this.minDate);

        this.maxDate = new Date(
          new Date().getTime() + 24 * 60 * 60 * 1000 * this.orderDetail.mostDays
        );
        console.log(this.maxDate);

        if (this.orderDetail.enableAppointmentThatDay) {
        }
      });
    },
    formatter(day) {
      const year = day.date.getFullYear();
      const month = day.date.getMonth() + 1;
      const date = day.date.getDate();
      const year_now = new Date().getFullYear();
      const month_now = new Date().getMonth() + 1;
      const date_now = new Date().getDate();

      if (year == year_now) {
        if (month == month_now) {
          if (date == date_now) {
            day.text = "今天";
          }
        }
      }

      const today = formatTime2(day.date);
      for (let i = 0; i < this.closeWeekArr.length; i++) {
        if (today == this.closeWeekArr[i]) {
          day.text = "今日不开放";
        }
      }
      return day;
    },
    getClosedDate() {
      getClosed({
        appMuseumId: this.museumId,
        month: "",
      }).then((res) => {
        console.log(res);
        let arr = [];
        for (let i = 0; i < res.data.data.length; i++) {
          arr.push(res.data.data[i].closeDate);
        }

        this.closeWeekArr = arr;
        this.formatter = this.formatter;
        console.log(this.closeWeekArr, "看关闭周");
      });
    },
    //弹出时间选择
    showPopup() {
      this.show = !this.show;
    },

    //时间换算
    getAllDate() {
      var datetime = new Date();
      var year = datetime.getFullYear();
      var month =
        datetime.getMonth() + 1 < 10
          ? "0" + (datetime.getMonth() + 1)
          : datetime.getMonth() + 1;
      var date =
        datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();

      this.currentDate = year + "-" + month + "-" + date;
      this.getSessionTime();
    },
    //添加游客
    addVisitor() {
      this.$router.push({
        path: "/addVisitor",
        query: { museumId: this.museumId },
      });
    },

    //编辑游客
    ediot(index) {
      this.$router.push({
        path: "/addVisitor",
        query: {
          index,
          museumId: this.museumId,
        },
      });
    },

    //我的历史订单
    myHistory() {
      this.$router.push({ path: "/historyDetail" });
    },

    //是否选中
    checked(item, index) {
      this.$store.commit("CHECKED", { index, checked: !item.isSelected });
    },

    //删除人
    deletePerson(index) {
      this.$store.commit("DELETEPER", index);
    },

    //获取日期
    GetDateStr(AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0

      this.currentDate = y + "-" + m + "-" + d;
      return y + "-" + m + "-" + d;
    },

    //选择出行日期
    chooseTravelDate(e) {
      var y = e.getFullYear();
      var m =
        e.getMonth() + 1 < 10 ? "0" + (e.getMonth() + 1) : e.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = e.getDate() < 10 ? "0" + e.getDate() : e.getDate(); //获取当前几号，不足10补0

      this.currentDate = y + "-" + m + "-" + d;
      this.getSessionTime();
      this.show = !this.show;
    },
    //获取入馆时间
    getSessionTime() {
      getSession({
        museumId: this.museumId,
        travelDate: this.currentDate,
      }).then((res) => {
        let a = res.data.data;

        this.sessionTimeArr = a;

        this.sessionTime = this.sessionTimeArr[0].sessionTime;
        this.perSonNum = this.sessionTimeArr[0].restNum;
      });
    },
    //打开到馆时间弹出框
    showSession() {
      this.show1 = !this.show1;
    },
    //到馆时间确认
    sessionConfirm(value) {
      this.sessionTime = value.sessionTime;
      this.perSonNum = value.restNum;
      this.show1 = !this.show1;
    },
    //到馆时间取消，关闭
    close() {
      this.show1 = !this.show1;
    },

    //立即预约
    yuyue() {
      if (!this.selected.length) {
        Toast("请选择出行人");
        return false;
      }
      if (!this.currentDate.length) {
        Toast("请选择出行日期");
        return false;
      }
      if (!this.sessionTime.length) {
        Toast("请选择到馆时间");
        return false;
      }
      if (this.perSonNum < this.selected.length) {
        Toast("剩余名额不够，请更换时间段");
        return false;
      }

      Appointment({
        arrivalTime: this.sessionTime, //到馆时间
        appMuseumId: this.museumId, //博物馆id
        reservationDate: this.currentDate, //出行日期
        identities: this.selected, //出行人信息
        channel: 1,
        formType: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.yuyueId = res.data.data.id;

          this.$router.push({
            path: "/success",
            query: { yuyueId: this.yuyueId },
          });
        } else {
          Toast(res.data.msg);
        }
      });
    },

    qingchu() {
      console.log(1);
      this.showWindows();
    },
    showWindows() {
      Dialog.confirm({
        title: "提示",
        message: "此操作会清除列表中所有添加的游客信息！是否继续？",
      })
        .then(() => {
          console.log("用户点击确定");
           this.$store.commit("CLEAR");
          console.log(this.$store.state.perSon);
          clearTravelerTemplates({}).then((res) => {
            console.log(res);
          });
        })
        .catch(() => {
          console.log("用户点击取消");
        });
    },

    //获取家庭关系
    getFamily() {
      var that = this;
      var base1 = new base();
      const tok = base1.encode(
        "d45a2aa8334a496a90cc743c654f2d03:9e997b8df0704e91b7a2145fef8ac7f0"
      );
      console.log(tok);
      const Basic = "Basic " + tok;
      axios
        .get(
          "https://szshfw.zjzwfw.gov.cn:1993/zlzhappserver/core/access/getCode",
          //   测试环境：https://szshfw.zjzwfw.gov.cn:1993/zlzhtest/zlzhappserver/
          //   ⽣产环境：https://szshfw.zjzwfw.gov.cn:1993/zlzhappserver/
          { headers: { Authorization: Basic } }
        )
        .then(function (response) {
          console.log(response.data.data);
          //   return
          that.$router.push({
            path: "shouquan",
            query: { code: response.data.data },
          });
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  overflow: scroll;
  padding: 0 30px;
  box-sizing: border-box;
  padding-bottom: 300px;
}

// 黄色背景模块
.museumInformation {
  margin-top: 30px;
  height: 168px;
  padding: 20px 0;
  width: 100%;
  color: white;
  box-sizing: border-box;
  position: relative;
  .shawdow {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    border-radius: 20px;
  }
  .topImg {
    width: 100%;
    height: 168px;
    position: absolute;
    top: 0;
    z-index: 1;
    border-radius: 20px;
  }
  .topTitle {
    font-weight: bold;
    font-size: 36px;
    z-index: 10;
    position: absolute;
    left: 40px;
    top: 30px;
    width: 590px;
    display: flex;
    align-items: center;
    height: 50px;
    img {
      width: 28px;
      height: 28px;
      margin-right: 20px;
    }
  }

  .topTitle2 {
    font-size: 24px;
    z-index: 10;
    position: absolute;
    left: 40px;
    bottom: 30px;
    width: 590px;
    display: flex;
    align-items: center;
    height: 50px;
    img {
      width: 28px;
      height: 28px;
      margin-right: 20px;
    }
  }
}

// 时间选择模块
.timeChoose {
  width: 100%;
  box-sizing: border-box;
  margin-top: 30px;
  background-color: white;
  border-radius: 20px;
  // padding: 20px;
  .van-cell__left-icon,
  .van-cell__right-icon {
    line-height: 45px;
  }
  .travelDate_text {
    font-size: 26px;
    display: inline-block;
    padding: 20px 0;
    float: left;
  }
  .travelDate_text2 {
    font-size: 24px;
    display: inline-block;
    padding: 20px 0;
    float: right;
    color: #888;
  }
  .sessionTime_text {
    font-size: 26px;
    display: inline-block;
    padding: 20px 0;
    float: left;
  }
  .sessionTime_text2 {
    font-size: 24px;
    display: inline-block;
    padding: 20px 0;
    float: right;
    color: #888888;
  }
  .shengyu {
    font-size: 30px;
    display: inline-block;
    padding: 20px 0;
    color: #707376;
  }
  .van-cell {
    background: none;
  }
}

// 添加游客模块
.addVisitors {
  width: 100%;
  background-color: white;
  border-radius: 20px;
  box-sizing: border-box;
  padding: 20px;
  margin-top: 30px;

  .add_one {
    display: inline-block;
    font-size: 26px;
    padding: 20px 0;
  }
  .add {
    width: 30px;
    height: 30px;
    display: inline-block;
    float: right;

    box-sizing: border-box;
    img {
      padding: 25px 0;
      width: 100%;
      height: 100%;
    }
  }
}

// 选择游客
.chooseVisitors {
  width: 100%;
  background-color: white;
  border-radius: 20px;
  box-sizing: border-box;
  padding: 30px;
  margin-top: 30px;

  // 选择标题
  .choose_title {
    font-size: 26px;
    margin-left: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    //获取家庭关系
    .perSon_information3 {
      padding: 10px;
      font-size: 26px;
      background-color: #ebf4ff;
      color: #00ae7e;
      text-align: center;

      border-radius: 10px;

      margin-right: 20px;

      .chooseImg {
        width: 30px;
        height: 30px;
        display: inline-block;
        margin-right: 10px;

        position: relative;
        top: 5px;
        img {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
  .appellation {
    font-weight: 600;
    font-size: 28px;
    .singleLimit {
      color: #999999;
      font-weight: 400;
      margin-left: 10px;
      font-size: 12px;
      display: inline-block;
    }
  }
  .qingchu {
    display: inline-block;
    /* border: 1px solid #03A181; */
    font-size: 13px;
    border-radius: 10px;
    margin-right: 40px;
    background-color: #eeeeee;
    color: #999999;
    padding: 10px;
  }

  // 选择事件点击
  .choose_person {
    display: flex;
    padding-left: 20rpx;
    flex-wrap: wrap;
    .perSon_information {
      width: 110px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-left: 10px;
      padding: 10px;
      font-size: 26px;
      background-color: #f6f7f9;
      color: #707376;
      text-align: center;
      margin-top: 30px;
      border-radius: 10px;
      box-sizing: border-box;
      margin-right: 10px;
    }
    .selected {
      border: 1px solid !important;
      background-color: #ebf4ff !important;
      color: #00ae7e !important;
    }
    .perSon_information2 {
      width: 100px;
      padding: 10px;
      font-size: 26px;
      background-color: #ebf4ff;
      color: #00ae7e;
      text-align: center;
      margin-top: 30px;
      border-radius: 10px;
      margin-left: 10px;
      margin-right: 10px;

      .chooseImg {
        width: 30px;
        height: 30px;
        display: inline-block;
        margin-right: 10px;

        position: relative;
        top: 5px;
        img {
          width: 30px;
          height: 30px;
        }
      }
    }
  }

  .van-cell__left-icon,
  .van-cell__right-icon {
    line-height: 48px;
  }
  //人员详细信息
  .perSon_Detail {
    width: 100%;
    display: flex;
    // justify-items: center;
    justify-content: space-between;
    align-items: center;

    .perSon_delete {
      width: 30px;
      height: 30px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .perSon_cardInformation {
      display: flex;
      flex-direction: column;
      margin-left: 30px;
      margin-right: 100px;
    }

    .perSon_ediot {
      align-self: center;

      color: #888888;
    }
  }
}

//我的历史订单模块
.myHistory {
  width: 100%;

  text-align: center;
  color: #00ae7e;

  margin-top: 50px;

  font-size: 26px;
}

//底部预约模块
.yuyueBottom_one {
  width: 100%;
  height: 40px;
  text-align: center;
  background-color: #efefef;
  position: fixed;
  bottom: 130px;
  color: #707376;
  font-size: 26px;
}
.yuyueBottom_two {
  width: 100%;
  height: 130px;
  background-color: white;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .num {
    width: 50%;
    text-align: left;
    padding-left: 30px;
    font-size: 28px;
    .number {
      font-size: 50px;
      color: #ec624f;
    }
  }
  .yuyueButton_box {
    padding-right: 30px;
    color: white;
    .yuyueButton {
      width: 250px;
      height: 80px;

      background-color: #00ae7e;
      border-radius: 50px;
      text-align: center;
      line-height: 80px;
      margin-right: -10px;
    }
  }
}
</style>

